import React from 'react';
import PropTypes from 'prop-types';
import ConnectedReport from './ConnectedReport';

// TODO: Move to react-viewerbase

function ReportRouting({ match }) {
  // TODO: Figure out which filters we want to pass in via a URL
  //const { patientId } = match.params;

  return <ConnectedReport />;
}

ReportRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default ReportRouting;
